export const enum ReportFilterMatchType {
  Equals = 'equals',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  Contains = 'contains',
  NotContains = 'notContains',
}
